import React from "react";
import { Award, Heart, Users, Sparkles, TrendingUp } from "lucide-react";

export const ValuesBanner = () => {
  const values = [
    {
      icon: Award,
      title: "Honor",
      description:
        "We uphold the dignity of every professional and the integrity of every project, fostering a culture of respect and excellence.",
      color: "from-green-600 to-green-700",
      bgColor: "bg-green-600/20",
    },
    {
      icon: Heart,
      title: "Relationships",
      description:
        "We believe growth comes from strong, lasting partnerships. We invest in deeply connected relationships with our clients and talents.",
      color: "from-green-600 to-green-700",
      bgColor: "bg-green-600/20",
    },
    {
      icon: Users,
      title: "People",
      description:
        "Our community is our strength. We are committed to the growth, well-being, and empowerment of the people who drive African excellence.",
      color: "from-yellow-400 to-yellow-500",
      bgColor: "bg-brand-yellow/20",
    },
    {
      icon: Sparkles,
      title: "Value",
      description:
        "We drive measurable impact by combining efficiency and innovation to fuel sustainable outcomes for businesses globally.",
      color: "from-green-600 to-green-700",
      bgColor: "bg-green-600/20",
    },
    {
      icon: TrendingUp,
      title: "Kaizen",
      description:
        "We are dedicated to learning, adapting, and refining our craft every single day, driving continuous improvement that leads to massive excellence",
      color: "from-orange-500 to-red-600",
      bgColor: "bg-orange-500/20",
    },
  ];

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 text-brand-primary">
            Our Core Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These principles guide every partnership, every project, and every
            professional relationship we build.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${value.color} opacity-0 group-hover:opacity-5 rounded-3xl transition-opacity duration-500`}
              ></div>

              <div
                className={`w-16 h-16 ${value.bgColor} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <value.icon
                  className={`w-8 h-8 bg-gradient-to-r ${value.color} bg-clip-text text-transparent`}
                  style={{ stroke: `url(#gradient-${index})` }}
                />
                <svg width="0" height="0">
                  <defs>
                    <linearGradient
                      id={`gradient-${index}`}
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >
                      <stop
                        offset="0%"
                        stopColor={
                          value.color.includes("blue")
                            ? "#2563eb"
                            : value.color.includes("green")
                              ? "#059669"
                              : value.color.includes("yellow")
                                ? "#fbdf64"
                                : value.color.includes("purple")
                                  ? "#9333ea"
                                  : value.color.includes("orange")
                                    ? "#f97316"
                                    : "#d946ef"
                        }
                      />
                      <stop
                        offset="100%"
                        stopColor={
                          value.color.includes("blue")
                            ? "#4f46e5"
                            : value.color.includes("green")
                              ? "#10b981"
                              : value.color.includes("yellow")
                                ? "#eab308"
                                : value.color.includes("purple")
                                  ? "#ec4899"
                                  : value.color.includes("orange")
                                    ? "#dc2626"
                                    : "#ec4899"
                        }
                      />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <h3 className="text-2xl font-bold mb-4 text-gray-800">
                {value.title}
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>

              <div
                className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${value.color} rounded-b-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
              ></div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 font-medium">
            These values aren't just words – they're the foundation of how we're
            building the future of work in Africa.
          </p>
        </div>
      </div>
    </section>
  );
};
